import VisibleComponent from './VisibleComponent'
import { getFilePathByRemoteUrl, getUrlParams, device, fireEvent } from "../../../common/util"
import App from "../../App"
import Message from '../../FrameMessage'
import {onAdShow} from "../../../api";
// import {getFilePathByRemoteUrl} from "../../../common/util";
// import * as nativeComponentListener from "../../../api/nativeComponentListener";

const [
    _iframe,
    _iframeSrc,
    _loadStatus,
    _onLoadListenerList,
    _loaded,
    _fireAdShow,
    _adShowed
] = [
    Symbol('_iframe'),
    Symbol('_iframeSrc'),
    Symbol('_loadStatus'),
    Symbol('_onLoadListenerList'),
    Symbol('_loaded'),
    Symbol('_fireAdShow'),
    Symbol('_adShowed')
]

function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
function guid() {
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
//uuid = guid();

(function () {
    const tplTempArea = document.createElement('DIV')
    tplTempArea.setAttribute('id', 'mtg-tpl-temp-area')
    tplTempArea.style.display = 'none'

    document.documentElement.appendChild(tplTempArea)
})();

export default class Container extends VisibleComponent {
    constructor(...props) {
        super(...props)
        this.element = this[_iframe] = document.createElement('iframe')
        this[_iframe].classList.add('container-iframe')
        this[_iframe].classList.add('mtg-tpl')
        this[_iframe].setAttribute('frameborder', 0)
        this[_iframeSrc] = undefined
        this[_onLoadListenerList] = []
        this[_loaded] = false
        this[_adShowed] = false
        this.id = guid() //+new Date()
        console.log('创建 iframe container =====> ', this.id)
        Message.onSubViewEmitMessage('templateLoadFinish', (data)=>{
            console.log('whenCampaignReady.templateLoadFinish ============>',data, data.id, this.id)
            if(data.id === this.id) {
                console.log('adShow onAdShow templateLoadFinish', this[_iframeSrc])
                !this[_adShowed] && this[_fireAdShow]()

            }
        })
        onAdShow((adShowData)=>{
            console.log('adShow onAdShow', this[_iframeSrc], this.id)
            !this[_adShowed] && this[_fireAdShow](adShowData)
        })

        fireEvent('ContainerViewCreated', {
            id: this.id,
            instance: this
        })
    }

    // 触发iframe内部页面的webviewshow
    [_fireAdShow](adShowData) {
        if (this[_iframeSrc] && (adShowData || App.adShowData)) {
            console.log('adShow onAdShow 发送adShow', this[_iframeSrc], this.id)
            this[_iframe].contentWindow.postMessage({
                action: 'webviewshow',
                data: JSON.parse(JSON.stringify(adShowData || App.adShowData))
            }, '*')
            this[_adShowed] = true
        }
    }

    getId() {
        return this.id
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    load(params, mountPoint) {
        //设置视图默认挂载点
        const defaultMountPoint = document.getElementById('mtg-tpl-temp-area')
        let mountPointEl = mountPoint && (mountPoint.el || mountPoint) || defaultMountPoint
        mountPointEl = mountPointEl.appendChild ? mountPointEl : defaultMountPoint

        this[_loadStatus] = new Promise((resolve, reject) => {
            this[_iframe].onload = (e) => {
                this[_loaded] = true

                // iframe被重新挂载在dom树上会导致被重新load，iframe内的页面将会丢失adshowData，
                // 所以将this[_adShowed]置为false 使adshowData重新发送给iframe内的页面
                this[_adShowed] = false

                //console.log('this.wv1  load success ', this[_iframe], params.content.fileURL)
                resolve()
                params.content.sdkSetting = params.content.sdkSetting || {}
                Object.assign(params.content.sdkSetting, {
                    instanceId: App.rootWebviewId, //this.id
                    iframeInstanaceId: this.id
                })
                const _data = {
                    action: 'initData',
                    data: {
                        boundingClientRect: mountPointEl? mountPointEl.getBoundingClientRect() : undefined,
                        viewInnerWidth: window.innerWidth,
                        viewInnerHeight: window.innerHeight,
                        content: params.content
                    }
                }
                const msgContent = JSON.parse(JSON.stringify(_data))
                console.log('load数据===========》', _data, msgContent)
                this[_iframe].contentWindow.postMessage(msgContent, '*')

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        this[_iframe].contentWindow.postMessage({
                            action: 'superViewResize',
                            data: {
                                boundingClientRect: mountPointEl? mountPointEl.getBoundingClientRect() : undefined,
                                viewInnerWidth: window.innerWidth,
                                viewInnerHeight: window.innerHeight
                            }
                        }, '*')
                    }, 0)
                }, false)


                /*this[_onLoadListenerList].forEach(cb=>{
                    console.log('onLoad.forEach--------准备加载Endcard！！：',this[_onLoadListenerList].length, cb)
                    cb(e)
                })*/
                while (this[_onLoadListenerList].length) {
                    console.log('onLoad.forEach--------遍历执行回调', this[_onLoadListenerList].length)
                    this[_onLoadListenerList].pop()()
                }
                //document.documentElement.removeChild(this[_iframe])
            }
        })
        console.log('this.wv1  load ', this[_iframe], params.content.fileURL)
        const pix = params.content.fileURL.indexOf('?') !== -1 ? '&' : '?'
        let src = params.content.fileURL + pix + 'createByIframe=true'
        //setTimeout(()=>{
            this[_iframeSrc] = src
            this[_iframe].src = src //params.content.fileURL
        //},5)
        //this[_iframe].style.display='none'
        //document.getElementById('mtg-tpl-temp-area').appendChild(this[_iframe])

        mountPointEl.appendChild(this[_iframe])

        return this[_loadStatus]
    }



    getElement() {
        return this[_iframe]
    }

    /**
     * 重新加载
     * @param params
     * @returns {*|Promise<any>}
     */
    reload(params) {
    }

    /**
     * 回退
     * @param params
     * @returns {*|Promise<any>}
     */
    goBack(params) {
    }

    /**
     * 重定向
     * @param params
     * @returns {*|Promise<any>}
     */
    goForward(params) {
    }

    postMessage(datas) {
        this[_iframe].contentWindow.postMessage(datas)
    }

    onLoad(cb) {
        'function' === typeof cb &&
            this[_onLoadListenerList].push(cb)
        console.log('Container-onLoad-！！：')
        if (this[_loaded]) {
            console.log('Container-onLoad-已触发将立即执行回调')
            cb()
        }
    }

    whenLoad() {
        return this[_loadStatus]
    }

    whenCampaignReady() {
        console.log('whenCampaignReady ============>',App)
        const promise = new Promise((resolve, reject)=>{
            Message.onSubViewEmitMessage('templateLoadFinish', (data)=>{
                console.log('whenCampaignReady.templateLoadFinish ============>',data, data.id, this.id)
                if(data.id === this.id){
                    resolve()
                }
            })
            Message.onSubViewEmitMessage('templateLoadFailure', (data)=>{
                console.log('whenCampaignReady.templateLoadFailure ============>',data, data.id, this.id)
                if(data.id === this.id){
                    reject({
                        msg:'iframe 加载campaign失败',
                        data
                    })
                }
            })
        })
        promise.catch((err) => {
            console.log(err)
        })
        return promise
    }

    destory() {
        let iframe = this[_iframe]
        iframe.src = "about:blank"
        iframe.contentWindow.document.write('')
        iframe.contentWindow.document.clear()
        iframe.contentWindow.close()
        iframe.parentNode.removeChild(iframe)
        iframe = null
        this[_iframe] = null
    }

    getLoadCampaignParams(url = '', campaigns, unitId, unitSetting, initData){
        return Container.getLoadCampaignParams(url, campaigns, unitId, unitSetting, initData)
    }

    static async getLoadCampaignParams(url = '', campaigns, unitId, unitSetting, initData) {
        //let rootWebviewId = data.sdkSetting.instanceId
        //let rootViewId = data.sdkSetting.rootViewInstanceId
        const data = JSON.parse(JSON.stringify(initData))
        const content = Object.assign({}, data, {
            campaignList: campaigns,
            campaigns,
            unitId,
            unitSetting
        })

        if (url.indexOf('.zip') !== -1) {
            let res = await getFilePathByRemoteUrl(url, unitId)
            let path = res.path

            if(device().isiOS){
                const query = getUrlParams(url)
                const foldername = query.foldername
                let rPath = path.substring(path.indexOf(foldername))
                let urlMd5 = path.match(/com\.mintegral\.cached\.default\.completed\/.*?\//)[0].split('/')[1] + '/'
                path = '../../'+ urlMd5 + rPath
                console.log('获取到相对路径',rPath, path)
            }
            content.fileURL = path
            content.filePath = path//为了兼容webview的getLoadCampaignParams
        } else if (url.indexOf('.html') !== -1) {
            content.fileURL = url
        }

        //content.fileURL = url
        console.log('正在获取load campaign参数===>：', content, initData, data)
        return {
            content
        }

    }

}
